import * as server from "@/utils/http"

export const _page = params => server.get("/dr-project/page", params);

export const _save = params => server.post(params.id ? "/dr-project/update" : "/dr-project/save", params);

export const _get = params => server.get("/dr-project/get", params);

export const _template=params=>server.download('/dr-project/template',params);

export const _upload = params => server.postfrom("/dr-project/upload", params);
